import { render } from "./AddProfesseur.vue?vue&type=template&id=843458f4&scoped=true&ts=true"
import script from "./AddProfesseur.vue?vue&type=script&lang=ts"
export * from "./AddProfesseur.vue?vue&type=script&lang=ts"

import "./AddProfesseur.vue?vue&type=style&index=0&id=843458f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-843458f4"]])

export default __exports__